// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
import { Position } from './position.js';
export class CommentGroup {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsCommentGroup(bb, obj) {
        return (obj || new CommentGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsCommentGroup(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new CommentGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    title(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    position(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new Position()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    width() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    height() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    color(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    static startCommentGroup(builder) {
        builder.startObject(6);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static addTitle(builder, titleOffset) {
        builder.addFieldOffset(1, titleOffset, 0);
    }
    static addPosition(builder, positionOffset) {
        builder.addFieldOffset(2, positionOffset, 0);
    }
    static addWidth(builder, width) {
        builder.addFieldFloat64(3, width, 0.0);
    }
    static addHeight(builder, height) {
        builder.addFieldFloat64(4, height, 0.0);
    }
    static addColor(builder, colorOffset) {
        builder.addFieldOffset(5, colorOffset, 0);
    }
    static endCommentGroup(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // id
        builder.requiredField(offset, 6); // title
        builder.requiredField(offset, 14); // color
        return offset;
    }
}
//# sourceMappingURL=comment-group.js.map